import { useContext } from 'react'
import useCommand from 'components/useCommand'
import CadFactionContext from 'components/CadFactionContextDefinition'

const CadUsefulDataContainer = ({ children }) => {
  const { loggedInFaction } = useContext(CadFactionContext)

  const {
    data: cadUsefulData,
    isPending: isPendingCadUsefulData,
  } = useCommand({
    command: 'CAD_GET_USEFUL_DATA',
    payload: { loggedInFaction },
  })

  return children({ 
    isPending: isPendingCadUsefulData, 
    data: cadUsefulData 
  })
}

export default CadUsefulDataContainer
